/* eslint-disable max-len */
/* eslint-disable eol-last */
import { createAction, props } from '@ngrx/store';

import { Site } from 'src/app/model/site';
import { TransferData } from 'src/app/model/transfer-data';

export const resetSites = createAction('RESET_SITES');
export const getSites = createAction('GET_SITES', props<{ userId?: number }>());
export const getSitesSuccess = createAction('GET_SITES_SUCCESS', props<{ sites: Site[] }>());
export const getSitesFailed = createAction('GET_SITES_FAILED', props<{ errorMessage: string }>());

export const getSitesOnlineDevices = createAction('GET_SITES_ONLINE_DEVICES', props<{ userId?: number }>());
export const getSitesOnlineDevicesSuccess = createAction('GET_SITES_ONLINE_DEVICES_SUCCESS', props<{ sites: Site[] }>());
export const getSitesOnlineDevicesFailed = createAction('GET_SITES_ONLINE_DEVICES_FAILED', props<{ errorMessage: string }>());

export const getSite = createAction('GET_SITE', props<{ siteId?: number }>());
export const getSiteSuccess = createAction('GET_SITE_SUCCESS', props<{ site: Site }>());
export const getSiteFailed = createAction('GET_SITE_FAILED', props<{ errorMessage: string }>());

export const setOwned = createAction('SET_OWNED', props<{ currentUserId: number }>());

export const addSite = createAction('ADD_SITE', props<{
    site: Site;
    background: { content?: string | ArrayBuffer; metadata?: File };
}>());
export const addSiteSuccess = createAction('ADD_SITE_SUCCESS', props<{
    site: Site;
    background: { content?: string | ArrayBuffer; metadata?: File };
    message: string;
}>());
export const addSiteFailed = createAction('ADD_SITE_FAILED', props<{ errorMessage: string }>());

export const updateSite = createAction('UPDATE_SITE', props<{
    site: Site;
    background: { content?: string | ArrayBuffer; metadata?: File };
}>());
export const updateSiteSuccess = createAction('UPDATE_SITE_SUCCESS', props<{
    site: Site;
    background: { content?: string | ArrayBuffer; metadata?: File };
    message: string;
}>());
export const updateSiteFailed = createAction('UPDATE_SITE_FAILED', props<{ errorMessage: string }>());

export const deleteSiteCleanup = createAction('DELETE_SITE_CLEANUP');
export const deleteSite = createAction('DELETE_SITE', props<{ id: number }>());
export const deleteSiteSuccess = createAction('DELETE_SITE_SUCCESS', props<{ id: number, message: string }>());
export const deleteSiteFailed = createAction('DELETE_SITE_FAILED', props<{ errorMessage: string }>());

export const deletingSharedSite = createAction('DELETING_SHARED_SITE');
export const deleteSharedSite = createAction('DELETE_SHARED_SITE', props<{ id: number }>());
export const deleteSharedSiteSuccess = createAction('DELETE_SHARED_SITE_SUCCESS', props<{ id: number, message: string }>());
export const deleteSharedSiteFailed = createAction('DELETE_SHARED_SITE_FAILED', props<{ errorMessage: string }>());

export const setCurrentSite = createAction('SET_CURRENT_SITE', props<{ siteId?: number }>());
export const setCurrentSiteSuccess = createAction('SET_CURRENT_SITE_SUCCESS', props<{ site: Site }>());
export const resetCurrentSite = createAction('RESET_CURRENT_SITE');

export const assignTechnician = createAction('ASSIGN_TECHNICIAN', props<{ siteId: number; technicianId: number }>());
export const assignTechnicianSuccess = createAction('ASSIGN_TECHNICIAN_SUCCESS', props<{ siteId: number; technicianId: number }>());
export const assignTechnicianFailed = createAction('ASSIGN_TECHNICIAN_FAILED', props<{ errorMessage: string }>());

export const unassignTechnician = createAction('UNASSIGN_TECHNICIAN', props<{ siteId: number }>());
export const unassignTechnicianSuccess = createAction('UNASSIGN_TECHNICIAN_SUCCESS', props<{ siteId: number }>());
export const unassignTechnicianFailed = createAction('UNASSIGN_TECHNICIAN_FAILED', props<{ errorMessage: string }>());

export const getSiteTransfers = createAction('GET_SITE_TRANSFERS');
export const getSiteTransfersSuccess = createAction('GET_SITE_TRANSFERS_SUCCESS', props<{ siteTransfers: TransferData[] }>());
export const getSiteTransfersFailed = createAction('GET_SITE_TRANSFERS_FAILED', props<{ errorMessage: string }>());

export const deleteSiteTransfer = createAction('DELETE_SITE_TRANSFER', props<{ id: number }>());
export const deleteSiteTransferSuccess = createAction('DELETE_SITE_TRANSFER_SUCCESS', props<{ transferId: number; message: string }>());
export const deleteSiteTransferFailed = createAction('DELETE_SITE_TRANSFER_FAILED', props<{ errorMessage: string }>());

export const resetTransferSite = createAction('RESET_TRANSFER_SITE');
export const transferSite = createAction('TRANSFER_SITE', props<{ email: string; firstName: string; lastName: string; siteId: number }>());
export const transferSiteSuccess = createAction('TRANSFER_SITE_SUCCESS', props<{ message: string }>());
export const transferSiteFailed = createAction('TRANSFER_SITE_FAILED', props<{ errorMessage: string }>());

export const confirmSiteTransfer = createAction('CONFIRM_SITE_TRANSFER', props<{
    siteId: number; ownerId: number; verification: string; userId?: number;
}>());
export const confirmSiteTransferSuccess = createAction('CONFIRM_SITE_TRANSFER_SUCCESS', props<{ message: string }>());
export const confirmSiteTransferFailed = createAction('CONFIRM_SITE_TRANSFER_FAILED', props<{ errorMessage: string }>());


// export const getThermoDevice = createAction('GET_THERMO_DEVICE', props<{ keycode: string }>());
// export const getThermoDeviceSuccess = createAction('GET_THERMO_DEVICE_SUCCESS', props<{ deviceThermo: Thermo }>());
// export const getThermoDeviceFailed = createAction('GET_THERMO_DEVICE_FAILED', props<{ errorMessage: string }>());


// export const updateThermo = createAction('UPDATE_THERMO', props<{
//     thermo: Thermo;
// }>());
// export const updateThermoSuccess = createAction('UPDATE_THERMO_SUCCESS', props<{ message: string }>());
// export const updateThermoFailed = createAction('UPDATE_THERMO_FAILED', props<{ errorMessage: string }>());

// export const openWebsocketThermo = createAction('OPEN_WEBSOCKET');
// export const closeWebsocketThermo = createAction('CLOSE_WEBSOCKET');

export const confirmSiteDeviceTransferShareError = createAction('CONFIRM_SITE_DEVICE_TRANSFER_SHARE_FAILED', props<{ errorMessage: string }>());

export const resetAddEditSiteForm = createAction('SITE_RESET_ADD_EDIT_FORM');

export const updateAutomationRtc = createAction('SITE_UPDATE_AUTOMATIONS_RTC', props<{
    siteId: number;
}>());
export const updateAutomationRtcSuccess = createAction('SITE_UPDATE_AUTOMATIONS_RTC_SUCCESS', props<{ message: string }>());
export const updateAutomationRtcFailed = createAction('SITE_UPDATE_AUTOMATIONS_RTC_FAILED', props<{ errorMessage: string }>());